export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])}
        }
      },
      "ar-EG": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])}
        }
      },
      "ar-SA": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب DutyPay"])}
        }
      },
      "de-DE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])}
        }
      },
      "de-AT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])}
        }
      },
      "de-CH": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoeinstellungen"])}
        }
      },
      "en-US": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account Settings"])}
        }
      },
      "en-GB": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Account Settings"])}
        }
      },
      "it-IT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni dell'Account DutyPay"])}
        }
      },
      "fr-FR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])}
        }
      },
      "es-ES": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Cuenta DutyPay"])}
        }
      },
      "pl-PL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Konta DutyPay"])}
        }
      },
      "nl-NL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Accountinstellingen"])}
        }
      },
      "bg-BG": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на DutyPay Aкаунт"])}
        }
      },
      "bs-BA": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke DutyPay Računa"])}
        }
      },
      "da-DK": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoindstillinger"])}
        }
      },
      "et-EE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konto Seaded"])}
        }
      },
      "fi-FI": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Tilin Asetukset"])}
        }
      },
      "el-GR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Λογαριασμού DutyPay"])}
        }
      },
      "he-IL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חשבון DutyPay"])}
        }
      },
      "ga-IE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuntais DutyPay"])}
        }
      },
      "ja-JP": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPayアカウント設定"])}
        }
      },
      "hr-HR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke DutyPay Računa"])}
        }
      },
      "lv-LV": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Konta Iestatījumi"])}
        }
      },
      "lt-LT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Paskyros Nustatymai"])}
        }
      },
      "pt-PT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Conta DutyPay"])}
        }
      },
      "ro-RO": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setările Contului DutyPay"])}
        }
      },
      "ru-RU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки учетной записи DutyPay"])}
        }
      },
      "sv-SE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay-Kontoinställningar"])}
        }
      },
      "sk-SK": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Účtu DutyPay"])}
        }
      },
      "cs-CZ": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Účtu DutyPay"])}
        }
      },
      "tr-TR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Ayarları"])}
        }
      },
      "hu-HU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Fiókbeállítások"])}
        }
      },
      "fr-BE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])}
        }
      },
      "fr-LU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du Compte DutyPay"])}
        }
      },
      "mt-MT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        }
      },
      "sl-SI": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve Računa DutyPay"])}
        }
      },
      "el-CY": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις Λογαριασμού DutyPay"])}
        }
      },
      "tr-CY": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Hesap Ayarları"])}
        }
      },
      "uk-UA": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Облікового Запису DutyPay"])}
        }
      },
      "zh-CN": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay 账户设置"])}
        }
      }
    }
  })
}
